import type { AppState } from '../core/types';
import type { LabelConfig } from '../presentation/config';

export function setLabelPositionOverride(config: LabelConfig, entityId: string, coordinate: readonly [number, number]): LabelConfig {
  return { ...config, positionOverrides: { ...config.positionOverrides, [entityId]: { coordinate: [...coordinate] } } };
}

export function resetLabelPositionOverrides(config: LabelConfig, entityIds?: ReadonlySet<string>): LabelConfig {
  if (!entityIds) return { ...config, positionOverrides: {} };
  const positionOverrides = Object.fromEntries(Object.entries(config.positionOverrides).filter(([id]) => !entityIds.has(id)));
  return { ...config, positionOverrides };
}

export function selectedLogicalLabelIds(state: AppState): ReadonlySet<string> {
  const result = new Set<string>();
  state.selectionSet.entries.forEach((entry) => {
    if (entry.source !== 'master') return;
    if (entry.kind === 'suerte' || entry.kind === 'tablon') result.add(entry.id);
    else if (entry.kind === 'fragment') {
      const fragment = state.model?.fragmentsById.get(entry.id);
      const id = state.labelConfig.target === 'tablon' ? fragment?.tablonId : fragment?.suerteId;
      if (id) result.add(id);
    }
  });
  if (!result.size && state.selection) {
    if (state.selection.kind === 'finca' || state.selection.kind === 'suerte' || state.selection.kind === 'tablon') result.add(state.selection.id);
    else {
      const fragment = state.model?.fragmentsById.get(state.selection.id);
      const id = state.labelConfig.target === 'tablon' ? fragment?.tablonId : fragment?.suerteId;
      if (id) result.add(id);
    }
  }
  return result;
}
